import { ChangeEvent, useState } from 'react';
import { TPersistentStorageHook, useSessionStorage } from 'src/utils';

export const useSearchFilter = ({
  key,
  defaultValue = '',
  regexValidator,
  isFilterFromUrl = false,
}: {
  key: string;
  defaultValue?: string;
  regexValidator?: RegExp;
  isFilterFromUrl?: boolean;
}) => {
  // Use regular useState when filter is from URL, otherwise use session storage
  const [localFilterValue, setLocalFilterValue] = useState(defaultValue);
  const [sessionFilterValue, setSessionFilterValue]: TPersistentStorageHook = useSessionStorage(
    defaultValue,
    key
  );

  const filterValue = isFilterFromUrl ? localFilterValue : sessionFilterValue;
  const setFilterValue = isFilterFromUrl ? setLocalFilterValue : setSessionFilterValue;

  const onFilterChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;

    if (regexValidator && (value === '' || regexValidator.test(value))) {
      setFilterValue(value);
    } else if (!regexValidator) {
      setFilterValue(value);
    }
  };

  const onClearFilter = () => {
    setFilterValue('');
  };

  return { onFilterChange, onClearFilter, filterValue };
};
